import React from 'react';
import { Box, Typography, Card, CardContent, CardMedia } from '@mui/material';
import { styled } from '@mui/system';

const DirectorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '20px',
  padding: '50px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column', // Stack cards vertically for small screens
    alignItems: 'center', // Center-align cards for small screens
  },
}));

const DirectorCard = styled(Card)(({ theme }) => ({
  flex: 1,
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
  borderRadius: '10px',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)', // Slight zoom effect on hover
    boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.3)',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%', // Full width for small screens
  },
}));

const DirectorCardMedia = styled(CardMedia)(({ theme }) => ({
  height: '300px',
  borderRadius: '10px 10px 0 0', // Rounded corners for the top of the card
}));

const DirectorCardContent = styled(CardContent)(({ theme }) => ({
  textAlign: 'center',
}));

function Director() {
  const directors = [
    {
      name: 'DG',
      role: 'Director General',
      image: '/img/dg.png',
      description:
        'Jane Doe is a visionary leader with years of experience in the industry. She oversees operations, drives innovation, and fosters a culture of excellence.',
    },
    {
      name: 'DGA',
      role: 'Director General Assistant',
      image: '/img/dg.png',
      description:
        'John Smith is a strategic thinker who ensures the organization stays ahead of the curve. He is dedicated to delivering exceptional results.',
    },
  ];

  return (
    <DirectorContainer>
      {directors.map((director, index) => (
        <DirectorCard key={index}>
          <DirectorCardMedia
            component="img"
            image={director.image}
            alt={director.name}
          />
          <DirectorCardContent>
            <Typography variant="h5" gutterBottom>
              {director.name}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              {director.role}
            </Typography>
            <Typography variant="body2">{director.description}</Typography>
          </DirectorCardContent>
        </DirectorCard>
      ))}
    </DirectorContainer>
  );
}

export default Director;